import { createFileRoute, redirect } from '@tanstack/react-router'
import { ReportsIndexScreen } from '@/features/hr-reports/reports-index-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/hr/reports/')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'hr_report.view')) throw redirect({ to: '/hr' })
  },
  component: ReportsIndexScreen,
})
